module.exports = __webpack_public_path__ + "static/media/icon.3c242e04.svg";